import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";
import { Table } from "../../components/DatabaseTable";
import { Column } from "../../components/DatabaseTable";

export const DatabaseTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      title: t("learn.database.table.item1.title"),
      supported: t("learn.database.table.item1.supported"),
    },
    {
      title: t("learn.database.table.item2.title"),
      supported: t("learn.database.table.item2.supported"),
    },
    {
      title: t("learn.database.table.item3.title"),
      supported: t("learn.database.table.item3.supported"),
    },
    {
      title: t("learn.database.table.item4.title"),
      supported: t("learn.database.table.item4.supported"),
    },
    {
      title: t("learn.database.table.item5.title"),
      supported: t("learn.database.table.item5.supported"),
    },
    {
      title: t("learn.database.table.item6.title"),
      supported: t("learn.database.table.item6.supported"),
    },
  ];
  const renderChecked = (value) => {
    const checkedIconStyl = {
      color: "#28B1B0",
      textAlign: "center",
      display: "block",
      marginRight: "10px",
    };
    const uncheckedIconStyl = {
      color: "#E02020",
      textAlign: "center",
      display: "block",
      marginRight: "10px",
    };
    const checkedIcon = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <i className="icon authing-icon authing-d" style={checkedIconStyl}></i>
        <span>{value}</span>
      </div>
    );
    const uncheckedIcon = (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <i className="icon authing-icon authing-x" style={uncheckedIconStyl}></i>
        <span>{value}</span>
      </div>
    );
    return value === t("learn.database.table.item1.supported") ? checkedIcon : uncheckedIcon;
  };
  const renderTitle = (value, data) => {
    return (
      <div className="colum-title" style={{ fontSize: 16 }}>
        <span>{value}</span>
      </div>
    );
  };
  return (
    <section className="database-table">
      <div className="inner">
        <div className="top">
          <Title title={t("learn.database.table.title")}>{t("learn.database.table.subtitle")}</Title>
        </div>
        <Table data={data}>
          <Column title={t("learn.database.table.manufacturer")} dataIndex="title" align="" render={renderTitle} />
          <Column
            title={t("learn.database.table.supported")}
            dataIndex="supported"
            align="center"
            render={renderChecked}
          />
        </Table>
      </div>
    </section>
  );
};
